export default function clearAdvancedSearchCookie() {
  document.cookie = 'pkgAdvancedSearch=false; path=/; max-age=0; SameSite=Lax; Secure'
}
